<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Kanban Adjust Upload</h5>
      <button type="button" class="btn-close" @click="closeKbaUploadModal"></button>
    </div>
    <div class="modal-body">
      <div class="row mb-2">
        <div class="col-md-3 col-sm-6 col-xs-12 p-r-0 mb-2 d-grid gap-2">
          <select v-model="kbaType" class="form-select">
            <option value="0">-- Select Adjust Type --</option>
            <option value="1">Adjust Factor</option>
            <option value="2">Adjust Dayoff</option>
          </select>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12 p-r-0 mb-2 d-grid gap-2">
          <input type="file" name="kba_file" class="form-control" id="kba_file" ref="kba_file" />
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12 p-r-0 mb-2">
          <button type="button" class="btn btn-info btn-sm btn-sm-fix" @click="checkAdjust" style="margin-right: 9px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyeglasses" viewBox="0 0 16 16" style="margin-right: 3px;">
              <path
                d="M4 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm2.625.547a3 3 0 0 0-5.584.953H.5a.5.5 0 0 0 0 1h.541A3 3 0 0 0 7 8a1 1 0 0 1 2 0 3 3 0 0 0 5.959.5h.541a.5.5 0 0 0 0-1h-.541a3 3 0 0 0-5.584-.953A1.993 1.993 0 0 0 8 6c-.532 0-1.016.208-1.375.547zM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
              />
            </svg>
            Check
          </button>
          <button type="button" class="btn btn-success btn-sm btn-sm-fix" @click="createAdjust" :disabled="isError == 1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-check" viewBox="0 0 16 16" style="margin-right: 3px;">
              <path
                d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"
              />
              <path d="M15.854 10.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 0 1 .707-.708l1.146 1.147 2.646-2.647a.5.5 0 0 1 .708 0z" />
            </svg>
            Create
          </button>
        </div>
      </div>
      <div class="row mb-3">
        <label>Kanban Adjust List</label>
        <div class="mb-3">
          <div class="table-responsive">
            <table class="table table-sm customize-table mb-0 v-middle">
              <thead class="table-light">
                <tr>
                  <th class="border-bottom border-top">#</th>
                  <th class="border-bottom border-top">Dock</th>
                  <th class="border-bottom border-top">Part ID</th>
                  <th class="border-bottom border-top">Part No.</th>
                  <th class="border-bottom border-top">Part Name</th>
                  <th class="border-bottom border-top text-right">Qty/Box</th>
                  <th class="border-bottom border-top">Unit</th>
                  <th class="border-bottom border-top">Supplier Code</th>
                  <th class="border-bottom border-top">Supplier Name</th>
                  <th class="border-bottom border-top">Supplier Plant Code</th>
                  <th class="border-bottom border-top text-right">Current</th>
                  <th class="border-bottom border-top text-right">New</th>
                  <th class="border-bottom border-top text-right">Change</th>
                  <th class="border-bottom border-top" v-if="kbaType == 1">Type</th>
                  <th class="border-bottom border-top text-right">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center" colspan="20" v-if="isLoadModal == true">
                    <i class="fas fa-sync-alt fa-spin fa-2x fa-fw"></i>
                  </td>
                </tr>
                <tr v-if="kbaData.length == 0 && isLoadModal == false">
                  <td class="text-center" colspan="20">No Data</td>
                </tr>
                <tr v-for="(row, i) in kbaData" :key="'pl' + i">
                  <td class="align-top">{{ i + 1 }}</td>
                  <td class="align-top">{{ row.dk_code }}</td>
                  <td class="align-top">{{ row.pr_id }}</td>
                  <td class="align-top">{{ row.pr_number }}</td>
                  <td class="align-top">{{ row.pr_name }}</td>
                  <td class="align-top text-right">{{ row.qty }}</td>
                  <td class="align-top">{{ row.unit }}</td>
                  <td class="align-top">{{ row.spl_code }}</td>
                  <td class="align-top">{{ row.spl_name }}</td>
                  <td class="align-top">{{ row.spl_pl_code }}</td>
                  <td class="align-top text-right">{{ row.kba_current }}</td>
                  <td class="align-top text-right">{{ row.kba_new }}</td>
                  <td class="align-top text-right">{{ row.kba_change }}</td>
                  <td class="align-top border-top" v-if="kbaType == 1">{{ row.kba_type }}</td>
                  <td class="align-top text-right">
                    <span v-show="row.is_error === 0" class="badge bg-success">Valid</span>
                    <span v-show="row.is_error === 1" class="badge bg-danger">Invalid</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
// import moment from 'moment'
import api from '../../models/KanbanAdjust'

export default {
  props: ['closeKbaUploadModal'],
  data() {
    return {
      isLoadModal: false,
      isError: true,
      kbaType: 0,
      kbaData: []
    }
  },
  mounted() {},
  methods: {
    checkAdjust() {
      this.kbaData = []
      let formData = new FormData()
      let kbaFile = document.querySelector('#kba_file')
      formData.append('kba_type', this.kbaType)
      formData.append('kba_file', kbaFile.files[0])
      this.isLoadModal = true
      api.checkAdjust(
        this.$store.state.URLHost,
        formData,
        this.header,
        result => {
          if (Object.keys(result.data).length > 0) {
            this.kbaData = result.data
          } else {
            this.kbaData = []
          }
          this.isError = result.is_error
          this.isLoadModal = false
          this.alert_msg('success', 'Successful.', result.message)
        },
        error => {
          this.isLoadModal = false
          this.alert_msg('success', 'Something went wrong.', error.message)
        }
      )
    },
    createAdjust() {
      Swal.fire({
        title: 'Kanban Adjust Upload',
        text: 'You want to Create Kanban Adjust?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, Create now!',
        cancelButtonText: 'Cancel'
      }).then(result => {
        if (result.value) {
          let kba_data = []
          if (this.kbaType === '1') {
            for (let item of this.kbaData) {
              kba_data.push({
                ps_id: item.ps_id,
                kba_current: item.kba_current,
                kba_new: item.kba_new,
                kba_change: item.kba_change,
                kba_type: item.kba_type,
                kba_t1: item.kba_t1_use,
                start_date: item.start_date,
                end_date: item.end_date,
                cdcl_list: item.cycle_list
              })
            }
          } else if (this.kbaType === '2') {
            for (let item of this.kbaData) {
              kba_data.push({
                ps_id: item.ps_id,
                kba_current: item.kba_current,
                kba_new: item.kba_new,
                kba_change: item.kba_change,
                kba_t1: item.kba_t1_use,
                kba_t2: item.kba_t2_use,
                start_date: item.start_date,
                mid_date: item.mid_date,
                end_date: item.end_date,
                cdcl_list: item.cycle_list
              })
            }
          } else {
            // error type
          }
          let formData = {
            kba_type: this.kbaType,
            kba_data: kba_data
          }
          api.createAdjust(
            this.$store.state.URLHost,
            formData,
            this.header,
            response => {
              kba_data = []
              this.kbaType = 0
              this.$refs.kba_file.value = null
              this.kbaData = []
              this.isError = 1
              this.alert_msg('success', 'Successful.', response.message)
            },
            error => {
              kba_data = []
              this.kbaType = 0
              this.$refs.kba_file.value = null
              this.kbaData = []
              this.isError = 1
              this.alert_msg('success', 'Something went wrong.', error.message)
            }
          )
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/KanbanAdjustUpload.vue